import Button from '../components/Button';
import Spacer from '../components/Spacer';
import { Helmet } from 'react-helmet-async';

function App() {
    return (
        <>
            <Helmet>
                <title>避難行動に関するアンケート</title>
                <meta name="description" content="火災時の避難行動に関するアンケートです。" />
            </Helmet>
                
            <div className="home">
                <Spacer sizePC="80" />
                <ul className="questionnaire-menu">
                    <li className="questionnaire-menu-item">
                        <div className="questionnaire-menu-item__inner" href="/department-store">
                            <div className="questionnaire-menu-item__content">
                                <h3 className="questionnaire-menu-item__title">避難行動に関するアンケート</h3>
                                <p className="questionnaire-menu-item__description">火災の際に”避難者がどのような行動をとるか”をアンケートします。</p>
                                <Button href={`${process.env.PUBLIC_URL}/index.html#smoke-room?group=A`} label="アンケートを開始する" />
                            </div>
                            <div className="questionnaire-menu-item__image">
                                <img src={`${process.env.PUBLIC_URL}/images/questionnaire-menu-item-01.jpg`} alt="火災が発生した建物の通路" width="480" height="320" />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default App;
